import { isBrowser as r } from "./is-browser.js";
const i = r && "chrome" in window;
r && navigator.userAgent.includes("Firefox");
const e = r && navigator.userAgent.includes("Safari") && !i;
export {
  i as isChrome,
  e as isSafari
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/env/browser.js
// module id = 937
// module chunks = 67